import { Reveal } from "./Reveal";
import { IMAGES } from "@/lib/images";

const CASES = [
    { img: IMAGES.remoteWork, label: "Télétravail", sub: "8h devant l’écran, sans douleur" },
    { img: IMAGES.pregnancy, label: "Grossesse", sub: "Un soutien doux du périnée" },
    { img: IMAGES.driver, label: "Conduite", sub: "Longs trajets sans engourdissement" },
    { img: IMAGES.wellness, label: "Détente", sub: "Canapé, lecture, convalescence" },
];

export default function UseCases() {
    return (
        <section className="py-20 lg:py-32 bg-cream">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                <Reveal className="max-w-2xl">
                    <p className="text-xs uppercase font-mono tracking-[0.25em] text-sage-mid">Modes de vie</p>
                    <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-[1.1]">
                        Pensé pour chaque <span className="italic text-sage">moment assis.</span>
                    </h2>
                </Reveal>
                <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
                    {CASES.map((c, i) => (
                        <Reveal key={i} delay={i * 0.1}>
                            <div data-testid={`usecase-card-${i}`} className="group relative overflow-hidden rounded-[1.75rem] aspect-[4/5]">
                                <img
                                    src={c.img}
                                    alt={c.label}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-sage-hover/85 via-sage-hover/10 to-transparent" />
                                <div className="absolute bottom-0 inset-x-0 p-6">
                                    <h3 className="font-serif text-2xl text-cream">{c.label}</h3>
                                    <p className="mt-1 text-sm text-cream/75">{c.sub}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
